// API Configuration
export const API_CONFIG = {
  // Change this to your production URL when deploying
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:8787',
  endpoints: {
    auth: {
      login: '/api/backend/auth/login',
      logout: '/api/backend/auth/logout',
      refresh: '/api/backend/auth/refresh',
      me: '/api/backend/auth/me',
      twoFactorSetup: '/api/backend/auth/2fa/setup',
      twoFactorVerify: '/api/backend/auth/2fa/verify',
      twoFactorDisable: '/api/backend/auth/2fa/disable',
      passwordResetRequest: '/api/backend/auth/password/request-reset',
      passwordReset: '/api/backend/auth/password/reset',
    },
    backend: {
      users: '/api/backend/users',
      roles: '/api/backend/roles',
      auditLogs: '/api/backend/audit-logs',
      settings: '/api/backend/settings',
      feeTemplates: '/api/backend/fee-templates',
      feeSchedules: '/api/backend/fee-schedules',
      feeTemplateScheduledChanges: '/api/backend/fee-template-scheduled-changes',
      chargers: '/api/backend/chargers',
      chargerTypes: '/api/backend/charger-types',
      sites: '/api/backend/sites',
      loadGroups: '/api/backend/load-groups',
      lmsTemplates: '/api/backend/lms-templates',
      lmsLogs: '/api/backend/lms-decision-logs',
      ocppTemplates: '/api/backend/ocpp-templates',
      ocppServers: '/api/backend/ocpp-servers',
      supabaseConnections: '/api/backend/supabase-connections',
      notificationGroups: '/api/backend/notification-groups',
      notificationLogs: '/api/backend/notification-logs',
      emailProviderRouting: '/api/backend/email-provider-routing',
      messages: '/api/backend/messages',
      banners: '/api/backend/promotion-banners',
      appUsers: '/api/backend/app-users',
      chargerFirmware: '/api/backend/charger-firmware',
      firmwareUpdates: '/api/backend/firmware-updates',
      chargingSessionsExport: '/api/backend/charging-sessions/export',
      kioskDevices: '/api/backend/kiosk-devices',
      kioskSettings: '/api/backend/kiosk-settings',
      kioskSettingDefinitions: '/api/backend/kiosk-setting-definitions',
    },
    fees: {
      calculate: '/api/backend/fees/calculate',
      preview: '/api/backend/fees/preview',
      structure: '/api/backend/fees/structure',
    },
    users: '/api/users',
    roles: '/api/roles',
    sites: '/api/sites',
    chargers: '/api/chargers',
    loadGroups: '/api/load-groups',
    sessions: '/api/sessions',
    transactions: '/api/transactions',
    reservations: '/api/reservations',
  },
};

// Cloudflare Turnstile site key for the admin login page.
// Empty string disables the widget on the frontend (e.g. local without a key).
// Dev/UAT use the Cloudflare test site key; production uses the real key.
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY || '';